import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

export function PageSkeleton() {
  return (
    <div className="flex flex-col min-h-[100dvh] bg-[#FDFBF9] p-4 relative">
      <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
        <div className="w-12 h-12 border-4 border-[#d4af35] border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-[#d4af35] font-bold animate-pulse text-sm">Bilgiler Yükleniyor...</p>
      </div>

      {/* Header Skeleton */}
      <div className="flex items-center justify-between mb-8 opacity-40">
        <Skeleton className="w-10 h-10 rounded-full" />
        <Skeleton className="w-32 h-6 rounded-full" />
        <Skeleton className="w-10 h-10 rounded-full" />
      </div>

      {/* Main Content Skeleton */}
      <div className="flex flex-col gap-4">
        <Skeleton className="w-full h-32 rounded-2xl" />
        <Skeleton className="w-full h-24 rounded-2xl" />
        <Skeleton className="w-full h-40 rounded-2xl" />
        <Skeleton className="w-full h-24 rounded-2xl" />
      </div>

      {/* Footer Nav Skeleton */}
      <div className="fixed bottom-0 left-0 right-0 h-20 bg-[#FDFBF9] border-t border-black/5 flex justify-around items-center px-4 pb-safe">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex flex-col items-center gap-1">
            <Skeleton className="w-8 h-8 rounded-full" />
            <Skeleton className="w-12 h-2 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  )
}
